import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const TableHeader = forwardRef<
	HTMLTableSectionElement,
	ComponentProps<'thead'>
>(({ className, ...props }, ref) => (
	<thead
		{...props}
		ref={ref}
		className={twMerge(
			'sticky -top-px z-20 bg-dm-black [&_td]:min-h-12 [&_td]:bg-dm-black [&_tr]:hover:!bg-inherit',
			className
		)}
	/>
));

TableHeader.displayName = 'TableHeader';

export default TableHeader;
